/**
 * Bottom tab bar: Главная, События, Профиль. Админ — через выбор роли или профиль.
 */

import { NavLink } from "react-router-dom";
import { useAuth } from "../../lib/auth.tsx";
import { getVisibleTabs, type MainTab } from "../../config/navigation.ts";
import {
  IconHome,
  IconHomeSolid,
  IconCalendar,
  IconCalendarSolid,
  IconUserCircle,
  IconUserCircleSolid,
} from "../Icons.tsx";

const ICON_MAP = {
  home: IconHome,
  calendar: IconCalendar,
  clock: IconCalendar,
  user: IconUserCircle,
  userCircle: IconUserCircle,
} as const;

const ICON_SOLID_MAP = {
  home: IconHomeSolid,
  calendar: IconCalendarSolid,
  clock: IconCalendarSolid,
  user: IconUserCircleSolid,
  userCircle: IconUserCircleSolid,
} as const;

const iconClass = "w-5 h-5 xs:w-5 xs:h-5 md-mobile:w-6 md-mobile:h-6 lg-mobile:w-6 lg-mobile:h-6 flex-shrink-0";

function TabIcon({ tab, isActive }: { tab: MainTab; isActive: boolean }) {
  const Icon = isActive ? ICON_SOLID_MAP[tab.icon] : ICON_MAP[tab.icon];
  return <Icon className={iconClass} />;
}

export function TabBar() {
  const { account } = useAuth();
  const tabs = getVisibleTabs(account ?? null);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 safe-area-bottom border-t border-slate-200/80 bg-white/80 backdrop-blur-md lg:hidden"
      role="tablist"
    >
      <div className="page-container">
        <div className="flex items-center h-[44px] xs:h-[46px] md-mobile:h-[48px] lg-mobile:h-[50px] pt-1 pb-1">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className="flex-1 min-w-0 flex items-center justify-center min-h-0"
            >
              <NavLink
                to={tab.path}
                end={tab.pathEnd === true}
                className={({ isActive }) =>
                  `tab-item ${isActive ? "tab-item-active" : ""}`
                }
                role="tab"
              >
                {({ isActive }) => (
                  <>
                    <TabIcon tab={tab} isActive={isActive} />
                    <span>{tab.label}</span>
                  </>
                )}
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
}
